import { ErrorHandling, SuccessHandling } from "../State";
import {
  fetchOTPEndPoint,
  validateOtp,
  homeOffersEndpoint,
  CarouselEndpoint,
  checkoutEndPoint,
  fetchMachineDetailEndPoint,
  fetchProductOfferIdEndPoint,
  fetchIpEndPoint,
  fetchProductDetailEndpoint,
  fetchOfferDetailEndPoint,
  otherCheckoutEndPoint,
  getCheckoutStatusEndpoint,
  getOfferListEndpoint,
  offerLoadingEventEndpoint,
  sendPaymentModeEventEndpoint,
  generatePinEndpoint,
  fetchContestEndpoint,
  fetchContestQuestionEndpoint,
  submitContestQuestionEndpoint,
  fetchWinnerDetailEndpoint,
  submitUpiDetailEndpoint,
  categoriesEndpoint,
  contactUsEndpoint,
} from "./apiEndPoints";
import { setUserInfo } from "./auth";
import { Base, Base3, Fandu } from "./config";
import {
  delete_data,
  get_data,
  get_data_hotdeals,
  get_data_public,
  get_excel_data,
  post_data,
  post_image,
  put_data,
  put_data_public,
  post_data_access,
  post_data_redeem,
} from "./NetworkHandler";
import { setDist, setHeader, setSelDist, setSlotId } from "../app/HomeReducer";
import store from "../app/store";

// DROPDOWN TOGGLE
export function toggle(index, class_name = "hide") {
  let child = document.getElementById(`child_${index}`);
  child.classList.toggle(class_name);
}

// CURRENT DATE TIME TOGETHER
export function getDateTime() {
  let date = new Date();
  let month = "";
  let currentDate = date.toLocaleDateString();
  let currentTime = date.toLocaleTimeString("en-US", { hour12: true });
  currentDate = currentDate.split("/");
  switch (currentDate[1]) {
    case "1":
      month = "Jan";
      break;

    case "2":
      month = "Feb";
      break;

    case "3":
      month = "Mar";
      break;

    case "4":
      month = "Apr";
      break;

    case "5":
      month = "May";
      break;

    case "6":
      month = "Jun";
      break;

    case "7":
      month = "Jul";
      break;

    case "8":
      month = "Aug";
      break;

    case "9":
      month = "Sep";
      break;

    case "10":
      month = "Oct";
      break;

    case "11":
      month = "Nov";
      break;

    case "12":
      month = "Dec";
      break;

    default:
      month = currentDate[1];
      break;
  }

  currentDate = `${month} ${currentDate[0]}, ${currentDate[2]}`;

  return currentTime + " , " + currentDate;
}

// deep copy of obj / array
export function deepCopyObject(obj) {
  let deepCopiedObj = JSON.parse(JSON.stringify(obj));
  return deepCopiedObj;
}

// formatdate in slot way
export function unformatDate(date) {
  if (date.length === 6) return date;
  date = date.split("-");
  date = date[2] + date[1] + date[0].substring(2);
  return date;
}

// formate date for input field
export function formatdate(date) {
  let ufDate = date;
  return `20${ufDate.substring(4)}-${ufDate.substring(2, 4)}-${ufDate.substring(
    0,
    2,
  )}`;
}

// LOGIN - send otp at login - post api
export async function sendOtpUtil(phone) {
  const url = Fandu + fetchOTPEndPoint;
  const customHeaders = {
    app_client: "webApp",
  };

  const data = { mobile: phone };

  return await post_data(url, data, customHeaders)
    .then((response) => {
      if (response) return response;
      else ErrorHandling(response.error.message);
    })
    .catch((error) => ErrorHandling(error.message));
}

// LOGIN - sign in with otp - post api
export async function signInUtil(phone, otp) {
  const url = `${Fandu}${validateOtp}`;
  const customHeaders = {
    app_client: "webApp",
  };

  const data = { mobile: phone, otp: otp };

  return await post_data(url, data, customHeaders)
    .then((response) => {
      // console.log(response);
      if (response) {
        setUserInfo(response);
        return response;
      } else {
        ErrorHandling(response.message);
      }
    })
    .catch((error) => ErrorHandling(error.message));
}

// HOME - get data at home, slot etc - get api
export async function setHomeStatus() {
  const response = {
    machine_id: 54356,
  };
  setUserInfo(response);
}

// get Fandu contest terms
export async function getContestTerms(userId) {
  const url = `${Fandu}${fetchContestEndpoint}`;

  return await get_data(url)
    .then((response) => {
      if (response) {
        return response.data;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}
// get Fandu contest terms
export async function getContestQuestion() {
  // const url = "https://outspokenly-unindulged-jenine.ngrok-free.dev/api/quiz/get/my/feed/v1/?category=&user_id=";
  const url = `${Fandu}quiz/get/my/feed/v1/?category=&user_id=`;
  // const url = "http://10.5.48.105:3000/api/quiz/get/questions/v1/";
  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('getOfferList',error);
      ErrorHandling(error.message);
      return null;
    });
}

export async function getAdvertisements(id) {
  // const url = `https://outspokenly-unindulged-jenine.ngrok-free.dev/api/feed/get/feed/v1/?widget_id=${id}`;
  const url = `${Fandu}feed/get/feed/v1/?widget_id=${id}`;
  // const url = "http://10.5.48.105:3000/api/quiz/get/questions/v1/";
  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('getOfferList',error);
      ErrorHandling(error.message);
      return null;
    });
}

export async function getHomeOfferDetails(categoryName) {
  const url = `${Base}${homeOffersEndpoint}?category=${categoryName}`;
  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

export async function getCategoriesDetails() {
  const url = `${Base}${categoriesEndpoint}`;
  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

export async function getCarouselDetails() {
  const url = `${Base}${CarouselEndpoint}`;
  // "http://10.5.50.218:4017/digital_offers/carousel/v1/";

  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

// 1 - Fandu submit questions
export async function submitQuestions(data) {
  const url =
    // "http://10.5.49.59:3000/api/quiz/submit/questions/v1/";
    `${Fandu}${submitContestQuestionEndpoint}`;
  // `https://outspokenly-unindulged-jenine.ngrok-free.dev/api/quiz/submit/questions/v1/`;
  const customHeaders = {
    app_client: "webApp",
  };
  return post_data(url, data, customHeaders)
    .then((response) => {
      if (response) {
        // console.log('generate fetchMachineDetail response', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      ErrorHandling(error.message);
    });
}

// get Fandu Winner detail
export async function getWinnerDetail(mobile) {
  let url = `${Fandu}${fetchWinnerDetailEndpoint}?mobile=${mobile}`;
  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('getOfferList',error);
      ErrorHandling(error.message);
      return null;
    });
}

// 1 - submit upi detail
export async function submitUpiDetail(data) {
  const url = `${Fandu}${submitUpiDetailEndpoint}`;
  const customHeaders = {
    app_client: "webApp",
  };
  return post_data(url, data, customHeaders)
    .then((response) => {
      if (response) {
        // console.log('generate fetchMachineDetail response', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      ErrorHandling(error.message);
    });
}

// 1 - machine detail
export async function fetchMachineDetail(data) {
  const url = `${Base}${fetchMachineDetailEndPoint}`;
  // "http://10.5.50.218:4010/machine/details";
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('generate fetchMachineDetail response', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      ErrorHandling(error.message);
    });
}

// 2 - Product and Offer Id
export async function fetchProductOfferId(data) {
  const url = `${Base}${fetchProductOfferIdEndPoint}`;
  // const url = `http://10.5.50.218:4012/mpo/details`;
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('generate fetchProductOfferId response', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('error fetchProductOfferId error',error);
      ErrorHandling(error.message);
    });
}

// 3 - Get IP Address
export async function fetchIpAddress(data) {
  const url =
    // `http://10.5.50.218:4002/ip_address/`;
    `${Base}${fetchIpEndPoint}`;
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('generate fetchIpAddress response', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchIpAddress error',error);
      ErrorHandling(error.message);
    });
}
// 4 - Get Product Detail
export async function fetchProductDetail(data) {
  const url = `${Base}${fetchProductDetailEndpoint}`;
  // const url = "http://10.5.50.218:4011/product/details/";
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('generate fetchProductDetail response', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate po error',error);
      ErrorHandling(error.message);
    });
}

// 4 - Get Offer Detail
export async function fetchOfferDetail(data) {
  const url =
    // `http://10.5.48.105:4013/offer/details`;
    `${Base}${fetchOfferDetailEndPoint}`;
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('generate po response', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate po error',error);
      ErrorHandling(error.message);
    });
}

export async function postHomeStatus(data) {
  const prodData = {
    prod_id: 123,
    name: "1 Ltr Bottle",
    price: 12,
    mrp: 20,
    max_qty: 3,
  };
  return prodData;
}

// send checkout
export async function checkoutProduct(checkoutData) {
  // const checkoutData = {
  //   "product_id": productsDetail.product_id,
  // "product_name": productsDetail.product_name,
  // "product_desc": productsDetail.description,
  // "product_mrp": productsDetail.mrp,
  // "product_offer_price": productsDetail.mrp,
  // "product_offer_id": offer.offer_id,
  // "product_promotion_discount": parseFloat(selQty * offer.offer_amount).toFixed(2), // calculated discount
  // "gst": parseFloat((selQty * (productsDetail.pd_price - offer.offer_amount))/ 18).toFixed(2), // gst calculated amount
  // "amount": selQty * (productsDetail.pd_price - offer.offer_amount), // payable amount
  // "device_id": machineUid,
  // "session_id": sessionId,
  // "user_id": '',
  // "order_session_id": orderSessionId,
  // "ip_address": ipAddress,
  // "order_timestamp": orderSessionTime,
  // "machine_id": mId,
  // "firstname":"Harsh",
  // "lastname":"Gupta",
  // "phone":"9663060044",
  // "email":"harsh@xyz.com",
  // "order_initiated_ts":"1717123343" //epoch timestamp
  // }

  const url = `${Base}${checkoutEndPoint}`;
  // const url = "http://10.5.50.218:4020/checkout/pd/v1/order";
  return post_data(url, checkoutData)
    .then((response) => {
      if (response) {
        // console.log('generate punnya response', response);
        // console.log('test url', https://testpay.easebuzz.in/pay/${response.data});
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate po error',error);
      ErrorHandling(error.message);
    });
}

// send checkout
export async function sendPaymentMode(data) {
  const url = `${Base}${sendPaymentModeEventEndpoint}`;
  // const url = "http://10.5.50.218:4021/checkout/pd/v1/payment-mode/";
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('checkout other punnya response', response);
        // console.log('test url', https://testpay.easebuzz.in/pay/${response.data});
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate payment gateway error', error);
      ErrorHandling(error.message);
    });
}

// send checkout
export async function checkoutOther(checkoutData) {
  const url = `${Base}${otherCheckoutEndPoint}`;
  return post_data(url, checkoutData)
    .then((response) => {
      if (response) {
        // console.log('checkout other punnya response', response);
        // console.log('test url', https://testpay.easebuzz.in/pay/${response.data});
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate payment gateway error', error);
      ErrorHandling(error.message);
    });
}

// generate dispance pin
export async function generateDispancePin(data) {
  const url = `${Base}${generatePinEndpoint}`;
  // const url = "http://10.5.50.218:4003/generate-pin/dispense/";
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('response of payment status', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      // ErrorHandling(error.message)
    });
}

// get checkout status
// 1 - machine detail
export async function getCheckoutStatus(data) {
  const url =
    // "http://10.5.50.218:4022/checkout/pd/v1/order-status/";
    `${Base}${getCheckoutStatusEndpoint}`;
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('response of payment status function', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      // ErrorHandling('server is not working')
    });
}

// get offer details
export async function getOfferList() {
  const url = `${Base}${getOfferListEndpoint}`;
  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('getOfferList',error);
      ErrorHandling(error.message);
      return null;
    });
}

// Event Post while offer loading
export async function offerEvent(data) {
  const url = `${Base}${offerLoadingEventEndpoint}`;
  // "http://192.168.101.100:3000/event-data";
  return post_data(url, data)
    .then((response) => {
      // if(response){
      //   console.log('response of offer event', response);
      //   return response;
      // }else{
      //   return Promise.reject(response.error)
      // }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      // ErrorHandling(error.message)
    });
}

// Event product  while products loading
export async function productEvent(data) {
  const url = `${Base}${offerLoadingEventEndpoint}`;
  // "http://10.5.49.59:4005/event-data";
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('response of payment status', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      // ErrorHandling(error.message)
    });
}

// get hot deals products
export async function getHotDealsProducts(productId = "") {
  const url = productId
    ? `${Base}digital_offers/products/v1/?product_id=${productId}`
    : `${Base}digital_offers/products/v1/`;
  // const url = productId
  //   ? `http://10.5.50.218:4017/digital_offers/products/v1/?product_id=${productId}`
  //   : "http://10.5.50.218:4017/digital_offers/products/v1/";

  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}
///digital_offers/product/order/v1/

export async function PlaceHotDealsOrder(data) {
  const url = `${Base}digital_offers/product/order/v1/`;
  // const url = "http://10.5.50.218:4017/digital_offers/product/order/v1/";
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('response of payment status', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      // ErrorHandling(error.message)
    });
}

export async function FetchUserDetails(data) {
  const url = `${Base}digital_offers/product/user/details/v1/`;
  // const url =  "http://10.5.50.218:4017/digital_offers/product/user/details/v1/";
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('response of payment status', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      // ErrorHandling(error.message)
    });
}

export async function CheckHotDealsOrderStatus(data) {
  const url = `${Base}digital_offers/product/order/status/v1/`;
  // const url =
  //   "http://10.5.50.218:4017/digital_offers/product/order/status/v1/";
  return put_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('response of payment status', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      ErrorHandling(error.message);
    });
}

//get quiz categories

export async function getQuizCategories() {
  const url =
    // "http://10.5.50.218:3000/api/quiz/get/categories/v1/";
    `${Fandu}quiz/get/categories/v1/`;
  return await get_data_public(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('getOfferList',error);
      ErrorHandling(error.message);
      return null;
    });
}

//get quiz categories questions

export async function getQuizCategoriesQuestions(slug, userId) {
  // const url = `http://10.5.49.59:3000/api/quiz/get/questions/v1/?quiz_category=${slug}&user_id=${userId}`;
  const url = `${Fandu}quiz/get/questions/v1/?quiz_category=${slug}&user_id=${userId}`;
  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('getOfferList',error);
      ErrorHandling(error.message);
      return null;
    });
}

// update claim points score
export async function UpdateClaimPoints(data) {
  // const url = "http://10.5.50.218:3000/api/payment/claim/credit/score/v2/";
  const url = `${Fandu}payment/claim/credit/score/v2/`;
  return put_data_public(url, data)
    .then((response) => {
      if (response) {
        // console.log('response of payment status', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      ErrorHandling(error.message);
    });
}

// export async function SubmitFreeGift(data) {
//   const url = `${Fandu}${updateQuizWinnerDetailsEndpoint}`;
//   // const url = "http://10.5.50.218:3000/api/quiz/update/user/winner/v1";
//   return put_data_public(url, data)
//     .then((response) => {
//       if (response) {
//         // console.log('response of payment status', response);
//         return response;
//       } else {
//         return Promise.reject(response.error);
//       }
//     })
//     .catch((error) => {
//       // console.log('generate fetchMachineDetail error',error);
//       // ErrorHandling(error.message)
//     });
// }

export async function getHotDealsOrderData(data) {
  const url = `${Base}admin/login/hotdeals/v1?phone=${data.phone}&otp=${data.otp}`;

  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

// UPDATE hot deals orders data
export async function updateHotDealsOrderData(data) {
  const url = `${Base}admin/update/order/status/v1`;

  return await put_data(url, data)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

// UPDATE Fandu Points
export async function updateFanduPoints(data) {
  const url =
    // "http://10.5.48.105:3000/api/payment/add/wallet/score/v1/";
    `${Fandu}payment/add/wallet/score/v1/`;

  return await put_data_public(url, data)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

// To identify user
export async function getUserIdentity({
  platformName,
  platformUserId,
  fanduUserId,
}) {
  const url =
    // `http://10.5.48.105:3000/api/mapping/identify/user/v1/?platform_name=${platformName}&platform_user_id=${platformUserId}&fandu_id=${fanduUserId}`;
    `${Fandu}mapping/identify/user/v1/?platform_name=${platformName}&platform_user_id=${platformUserId}&fandu_id=${fanduUserId}`;

  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

//user mapping
export async function mappingUser(data) {
  const url =
    // "http://10.5.48.105:3000/api/mapping/link/fandu/user/v1/";
    `${Fandu}mapping/link/fandu/user/v1/`;
  return post_data(url, data)
    .then((response) => {
      if (response) {
        // console.log('response of payment status', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      // ErrorHandling(error.message)
    });
}

// get rewards listing
export async function getRewardsListing() {
  const url =
    // "http://10.5.48.105:3000/api/offers/platform/offers/v1/";
    `${Fandu}offers/platform/offers/v1/`;

  return await get_data(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

//redeem rewards
export async function RedeemRewards(data) {
  const url =
    // "http://10.5.49.59:3000/api/offers/platform/offers/redeem/v1";
    `${Fandu}offers/platform/offers/redeem/v1`;
  return post_data_redeem(url, data)
    .then((response) => {
      if (response) {
        // console.log('response of payment status', response);
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      // console.log('generate fetchMachineDetail error',error);
      // ErrorHandling(error.message)
    });
}

//update fandu id
export async function updateFanduUser(data) {
  const url =
    //  "http://10.5.48.105:3000/api/mapping/update/user/id/v1/";
    `${Fandu}mapping/update/user/id/v1/`;

  return await put_data_public(url, data)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

//update redeemed offer
export async function offerRedeemedSuccess(data) {
  const url =
    // "http://10.5.48.105:3000/api/offers/platform/offers/update/v1";
    `${Fandu}offers/platform/offers/update/v1`;

  return await put_data_public(url, data)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

export async function userRedeemHistory() {
  const url = `${Fandu}offers/platform/offers/history/v1`;
  return await get_data_public(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

export async function userLeaderboard() {
  const url = `${Fandu}contest/leaderboard/v1/`;
  return await get_data_public(url)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}

export async function contactUsUTR(utrNumber) {
  const url = 
  // `http://10.171.94.114:4050/${contactUsEndpoint}`;
  `${Base3}${contactUsEndpoint}`;

  const data = {
    utr_value: utrNumber,
  };

  return await post_data(url, data)
    .then((response) => {
      if (response) {
        return response;
      } else {
        return Promise.reject(response?.error);
      }
    })
    .catch((error) => {
      ErrorHandling(error.message);
      return null;
    });
}
